import { AuthError } from '@azure/msal-browser';

/** Only protocol responses requiring user interaction are expected here. */
const EXPECTED_CODES = new Set([
  'login_required',
  'interaction_required',
  'consent_required',
]);

/**
 * Build a token-free diagnostic. Never forward the original error, message,
 * stack or cause: provider/library errors can contain request or token data.
 */
export function silentSessionRescueError(
  error: unknown,
  requestCorrelationId: string,
): Error | null {
  if (error instanceof AuthError && EXPECTED_CODES.has(error.errorCode)) {
    return null;
  }
  const errorCode =
    error instanceof AuthError && /^[a-z][a-zA-Z0-9_]{0,79}$/.test(error.errorCode)
      ? error.errorCode
      : 'unexpected_error';
  const correlationId =
    error instanceof AuthError &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      error.correlationId,
    )
      ? error.correlationId
      : requestCorrelationId;
  return new Error(
    `Silent session recovery failed: ${errorCode} (correlation id ${correlationId})`,
  );
}
